import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    gridItemContainer: {
        boxShadow: "0px 2px 9px rgba(19, 61, 133, 0.15)",
        borderRadius: 10,
        padding: `${theme.spacing(1)} ${theme.spacing(4)} 0 ${theme.spacing(4)}`,
        height: "48%",
        display: "flex",
        justifyContent: "space-between",
    },
    trafficLightContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "20%",
    },
    machineCenterNameContainer: {
        paddingTop: "15px",
        height: "15%",
    },
    machineCenterNameSmall: {
        minHeight: 30,
        fontSize: "16px !important",
        color: theme.palette.text.primary,
        fontWeight: "600 !important",
    },
    machineCenterNameMedium: {
        minHeight: 35,
        fontSize: "20px !important",
        color: theme.palette.text.primary,
        fontWeight: "600 !important",
    },
    timerContainer: {
        minHeight: 35,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .MuiTypography-root": {
            fontSize: "20px !important",
        },
    },
    plcErrorContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "20%",
        "& .MuiTypography-root": {
            color: theme.palette.error.main,
            fontSize: 10,
        },
    },
    downtimePendingContainer: {
        background: theme.palette.error.lighter,
        border: `2px solid ${theme.palette.error.main}`,
        minHeight: 56,
    },
    downtimePendingTitle: {
        borderRadius: 14,
        color: theme.palette.error.main,
        background: theme.palette.error.background,
        padding: theme.spacing(1),
    },
    downtimePendingTitleContainer: {
        height: "25%",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        overflow: "hidden",
        paddingBottom: theme.spacing(1),
    },
    plcDownWarning: {
        lineHeight: "unset",
    },
    warningTitleSmall: {
        fontSize: "12px !important",
    },
    warningTitleMedium: {
        fontSize: "15px !important",
    },
    warningTitleLarge: {
        fontSize: "20px !important",
    },
    uptimeDowntimeBarContainer: {
        height: "15%",
    },
    noData: {
        padding: `${theme.spacing(2)} 0`,
    },
}));
